import { Position } from "@/components/Svg";
import CSelect from "@/components/main/form/CSelect";
import firebase_app from "@/lib/firebase/configs";
import { Loader } from "@mantine/core";
import { useDebouncedState } from "@mantine/hooks";
import {
  addDoc,
  collection,
  endAt,
  getDocs,
  getFirestore,
  limit,
  orderBy,
  query,
  startAt,
} from "firebase/firestore";
import { useEffect, useState } from "react";

const ServiceInput = ({ dictionary, form }) => {
  const [services, setServices] = useState([]);
  const [search, setSearch] = useDebouncedState("", 300);
  const [loading, setLoading] = useState(false);
  const createType = async (type) => {
    try {
      const db = getFirestore(firebase_app);
      await addDoc(collection(db, "CompanyServices"), {
        name: type,
        lowerCaseName: type.toLowerCase(),
      });
    } catch (error) {}
  };

  const getTypes = async (search, inital = false) => {
    try {
      setLoading(true);
      const db = getFirestore(firebase_app);
      const q = inital
        ? query(
          collection(db, "CompanyServices"),
          orderBy("lowerCaseName"),
          limit(4)
        )
        : query(
          collection(db, "CompanyServices"),
          orderBy("lowerCaseName"),
          startAt(search.toLowerCase()),
          endAt(search.toLowerCase() + "\uf8ff"),
          limit(4)
        );
      const querySnapshot = await getDocs(q);
      let typesQueried = [];
      querySnapshot.forEach((doc) => {
        const data = doc.data();
        typesQueried.push(data?.name);
      });

      setServices(typesQueried);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    getTypes("", true);
  }, []);

  useEffect(() => {
    if (search.length > 0) {
      getTypes(search);
    }
  }, [search]);

  return (
    <CSelect
      searchable
      creatable
      data={
        form.values.title
          ? Array.from(new Set([form.values.title, ...services]))
          : services
      }
      placeholder={dictionary.title}
      className="mt-3"
      icon={<Position />}
      onSearchChange={(query) => {
        setSearch(query);
      }}
      onCreate={(value) => {
        setServices((data) => [...data, value]);
        form.setFieldValue("type", value);
        createType(value);
      }}
      getCreateLabel={(query) => {
        return (
          <>
            <span className="text-primary">{dictionary.createItem}: </span>
            {query}
          </>
        );
      }}
      rightSection={loading && <Loader variant="oval" />}
      {...form.getInputProps("title")}
    />
  );
};

export default ServiceInput;
